import EditRole from './EditRole';
import Role from './Role';

const RoleConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/roles',
      element: <Role />,
    },
    {
      path: '/addRole/',
      element: <EditRole />,
    },
    {
      path: '/roles/edit/:id',
      element: <EditRole />,
    },
  ],
};

export default RoleConfig;
